'use client';
import { ReactNode, useEffect, useState } from 'react';

export function FadeInDiv({ children }: any) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    setShow(true);
  }, []);

  return (
    <div className={`transition-all duration-500 ${show ? 'opacity-100' : 'opacity-0'}`}>
      {children}
    </div>
  );
}